import object from 'helpers/object'


export const initialState = {
  isFetching: true,
  poll: [],

  // projects: [],
  // project: {},
  // votes: {},
  // myVotes: [],
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setPoll = (state, payload) => (
  object.setIn(state, [ 'poll' ], payload)
)

// export const setProjects = (state, payload) => (
//   object.setIn(state, [ 'projects' ], payload)
// )
//
// export const setProject = (state, payload) => (
//   object.setIn(state, [ 'project' ], payload)
// )
//
// export const setVotes = (state, payload) => (
//   object.setIn(state, [ 'votes', payload.votingId ], payload.votes)
// )
//
// export const setMyVotes = (state, payload) => (
//   object.setIn(state, [ 'myVotes' ], payload)
// )
